import { gql } from '@apollo/client'

// export const activateManageableFeature = gql`
//   mutation activateManageableFeature($manageableFeatureId: Number!) {
//     activateManageableFeature(id: $manageableFeatureId) {
//       id
//       active
//     }
//   }
// `

// export const deactivateManageableFeature = gql`
//   mutation deactivateManageableFeature($manageableFeatureId: Number!) {
//     deactivateManageableFeature(id: $manageableFeatureId) {
//       id
//       active
//     }
//   }
// `

export const activateManageableFeature = gql`
  query Teste2 {
    me {
      id
    }
  }
`

export const deactivateManageableFeature = gql`
  query Teste3 {
    me {
      id
    }
  }
`

export const createArticleMutation = gql`
  mutation createArticle($input: CreateArticleInput!) {
    createArticle(input: $input) {
      id
      title
      subtitle
      imageAuthor
      htmlContent
      degree
      schoolSegment {
        value
        label
        abbreviation
        recommendedDegrees
      }
      coverTitle
      coverSubtitle
      author
    }
  }
`

export const updateArticleMutation = gql`
  mutation updateArticle($input: UpdateArticleInput!) {
    updateArticle(input: $input) {
      id
      title
      subtitle
      imageAuthor
      htmlContent
      degree
      schoolSegment {
        value
        label
        abbreviation
        recommendedDegrees
      }
      coverTitle
      coverSubtitle
      author
    }
  }
`

export const qualifyUserJobDescription = gql`
  mutation qualifyUserJobDescription(
    $targetUserId: Int!
    $jobPositions: [JobPosition]!
  ) {
    qualifyUserJobDescription(
      targetUserId: $targetUserId
      jobPositions: $jobPositions
    ) {
      id
      jobPositions
    }
  }
`

export const updateUserRole = gql`
  mutation updateUserRole($roleName: String!, $userId: Int!) {
    changeRole(roleName: $roleName, userId: $userId) {
      id
      roles
    }
  }
`

export const editManyUsersMutation = gql`
  mutation editManyUsers($file: Upload!, $queryType: String!) {
    editManyUsers(file: $file, queryType: $queryType) {
      name
      email
      accessToken
    }
  }
`

export const listBooksByCsvMutation = gql`
  mutation listBooksByCsv(
    $file: Upload!
    $queryType: ListBooksByCsvQueryType!
  ) {
    listBooksByCsv(file: $file, queryType: $queryType) {
      id
      name
      author
      imageUrlThumb
    }
  }
`

export const addBooksToCollectionMutation = gql`
  mutation addBooksToCollection($collectionId: Int!, $bookIds: [Int!]!) {
    addBooksToCollection(collectionId: $collectionId, bookIds: $bookIds)
  }
`

export const editExamQuestionsMutation = gql`
  mutation EditExamQuestion($params: [EditExamQuestionPayload]) {
    editExamQuestions(params: $params) {
      examQuestionId
      id
      isCorrect
      statement
    }
  }
`

export const processOnixFileMutation = gql`
  mutation processOnixFile($isbn: String!) {
    processOnixFile(isbn: $isbn)
  }
`

export const listClientsByCsvMutation = gql`
  mutation listClientsByCsv($file: Upload!) {
    listClientsByCsv(file: $file) {
      id
      name
    }
  }
`

export const deactivateClientsMutation = gql`
  mutation deactivateClients($clientIds: [Int]!) {
    deactivateClients(clientIds: $clientIds) {
      id
      deactivated
      errorMessage
    }
  }
`
